export default {
  usersEndpoints: '/users',

  churchMapEndpoint: '/church-map',
  departmentsEndpoint: '/departments',
  memberStatusEndpoint: "/member-status",
  applicationsEndpoint: '/applications',
  memberTypesEndpoint: '/member-types',
  memberTitlesEndpoint: '/member-titles',
  educationEndpoint: '/education',
  userEducationEndpoint: '/user/education',
  userWorkHistoryEndpoint: '/user/work-experience',
  workHistoryEndpoint: '/work-experience',
  memberProfilesEndpoint: '/member-profiles',
  memberDesignationsEndpoint: '/member-designations',
  stationsServedEndpoint: '/stations-served',

  logsEndpoint: '/logs',
  apiEndpoint: '/api-keys',
  auditTrailEndpoint: '/audit-trail',

  // The unified activity log. Supersedes logsEndpoint and auditTrailEndpoint, which are kept
  // because the older User Logs and Audit Trail screens still read them (both now served from
  // the same collection, projected back into their original response shape).
  activityLogsEndpoint: '/activity-logs',

  // v2 partner api clients — admin-scoped, so it sits behind /admin like the rest of
  // the audit-trailed admin surface.
  apiClientsEndpoint: '/admin/api-clients',

  searchEndpoint: '/search',
  settingsEndpoint: '/settings',
  dashboardEndpoint: '/dashboard',

  permissionsEndpoint: '/permissions',

  csvUploadsEndpoint: '/csv-uploads',
  sampleCSVFileEndpoint: '/sample-csv-file',
  exportTemplatesEndpoint: "/csv/exports/templates",
  sendgridTemplatesEndpoint: '/sendgrid/templates',
}
